<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>规格管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="title" align="center" label="规格"> </el-table-column>

        <el-table-column prop="weight" align="center" label="重量">
          <template slot-scope="scope">
            <span>{{ scope.row.weight }}g</span>
          </template>
        </el-table-column>

        <el-table-column prop="pieceUnit" align="center" label="计价方式">
          <template slot-scope="scope">
            <span v-if="scope.row.pieceUnit === 0">计重</span>
            <span v-if="scope.row.pieceUnit === 1">计件</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.id)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :rules="checkItemParams" :model="itemParams" label-width="120px">
          <!--<el-form-item prop="specificationName" label="规格名称：">-->
          <!--<el-select-->
          <!--size="small"-->
          <!--v-model="itemParams.specificationName"-->
          <!--placeholder="请选择规格名称">-->
          <!--<el-option-->
          <!--v-for="item in specificationNameList"-->
          <!--:label="item.label"-->
          <!--:value="item.value"-->
          <!--:key="item.value">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-button-->
          <!--type="text"-->
          <!--size="small"-->
          <!--@click="isAdd = true">-->
          <!--新增规格名称-->
          <!--</el-button>-->
          <!--</el-form-item>-->

          <!--<el-form-item-->
          <!--v-if="isAdd"-->
          <!--prop="addSpecificationName"-->
          <!--label="新增规格名称：">-->
          <!--<el-input-->
          <!--size="small"-->
          <!--v-model="itemParams.addSpecificationName"-->
          <!--placeholder="请添加规格">-->
          <!--</el-input>-->
          <!--</el-form-item>-->

          <el-form-item prop="title" label="规格：">
            <el-input size="small" v-model="itemParams.title" placeholder="请输入规格"> </el-input>
          </el-form-item>

          <el-form-item prop="weight" label="重量：">
            <el-input size="small" v-model="itemParams.weight" placeholder="请输入重量">
              <template slot="append">g</template>
            </el-input>
          </el-form-item>

          <el-form-item prop="pieceUnit" label="计价方式：">
            <el-select style="width: 100%" size="small" v-model="itemParams.pieceUnit" placeholder="请选择计价方式">
              <el-option :value="0" label="计重"></el-option>
              <el-option :value="1" label="计件"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button :disabled="isDisabled" size="small" type="primary" @click="saveSpecification('dialogForm')"> 保 存 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    const checkIsInteger = function (rule, value, callback) {
      if (value) {
        value = value + "";
        if (value % 1 === 0 && value.indexOf(".") === -1 && parseInt(value) !== 0) {
          callback();
        } else if (parseInt(value) === 0) {
          callback(new Error("重量不能为0"));
        } else {
          callback(new Error("重量只能是整数"));
        }
      } else {
        callback(new Error("请输入重量"));
      }
    };
    return {
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: "",
      dialogVisible: false,
      itemParams: {
        title: "",
        weight: "",
        pieceUnit: 0,
        supplyId: "",
      },
      checkItemParams: {
        title: [{ required: true, message: "请输入规格", trigger: "blur" }],
        weight: [{ validator: checkIsInteger }, { required: true, message: "请输入重量", trigger: "blur" }],
        pieceUnit: [{ required: true, message: "请选择计价方式", trigger: "change" }],
      },
      method: "",
      isAdd: false,
      isDisabled: false,
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/good/goodspec/findByPage",
        method: "GET",
        params: {
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 新增分类管理
     */
    toCreate() {
      this.dialogVisible = true;
      this.dialogTitle = "新增规格";
      this.method = "POST";
      if (this.itemParams.id) {
        delete this.itemParams.id;
      }
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 保存新增或编辑规格
     * @param name
     */
    saveSpecification(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$http({
            url: global.apiUrl + "/good/goodspec",
            method: this.method,
            body: this.itemParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.dialogVisible = false;
                this.isDisabled = false;
                this.$message.success(res.body.info);
                this.loadTableData();
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              this.isDisabled = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
      this.itemParams.title = "";
      this.itemParams.weight = "";
      this.itemParams.pieceUnit = 0;
      this.isAdd = false;
    },
    /**
     * 编辑条目数据
     * @param row
     */
    editItem(row) {
      this.dialogTitle = "编辑规格";
      this.dialogVisible = true;
      this.method = "PUT";
      Object.assign(this.itemParams, row);
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/good/goodspec",
        method: "DELETE",
        params: {
          id: id,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.itemParams.supplyId = parseInt(vm.$route.params.supplyId);
    });
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
